import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabViewModule } from 'primeng/tabview';
import { FbAuctionComponent } from './fb-auction.component';
import { FbAuctionCardModule } from './fb-auction-card/fb-auction-card.module';


@NgModule({
  imports: [
    CommonModule,
    FbAuctionCardModule,
    TabViewModule

  ],
  declarations: [FbAuctionComponent],
  exports : [FbAuctionComponent]
})
export class FbAuctionModule { }
